import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// API to fetch client details
export const fetchClients = async (
  coachId,
  sortOrder,
  page,
  pageSize,
  filter,
  searchKey,
  sortBy = "CreatedOn"
) => {
  let url = `${Endpoints.GET_CLIENTS}/${coachId}?sortOrder=${sortOrder}&sortBy=${sortBy}&PageNumber=${page}&PageSize=${pageSize}`;
  if (filter) {
    url += `&filter=${filter}`;
  }

  if (searchKey) {
    url += `&searchKey=${searchKey}`;
  }

  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    return error;
  }
};

// API to fetch client filters count
export const fetchFilterCounts = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_CLIENTS_LIST_FILTER_OPTIONS}?coachId=${coachId}`
  );
  return response.data;
};
